import { useEffect, useState } from 'react';
import useAuthStore from '../store/authStore';
import { getUpworkFeedStatus } from '../services/upworkMcpService';
import UpworkRecommendedFeed from './UpworkRecommendedFeed';

// Keep existing feeds mounted, preserving filters, scroll/modal state and in-flight actions.
export default function UpworkFeedSwitcher({ children }) {
  const { user, isAuthenticated } = useAuthStore();
  const scope = `${user?._id || ''}:${user?.tenantId?._id || user?.tenantId || ''}`;
  const [enabledScope, setEnabledScope] = useState(null);
  const [selection, setSelection] = useState(null);
  const enabled = isAuthenticated && enabledScope === scope;
  const upwork = enabled && selection === scope;
  useEffect(() => {
    let cancelled = false;
    setEnabledScope(null);
    setSelection(null);
    if (isAuthenticated) getUpworkFeedStatus().then((status) => {
      if (!cancelled && status.enabled) setEnabledScope(scope);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [scope, isAuthenticated]);
  return <>
    {enabled && <nav aria-label="Job feed source" className="mb-4 flex gap-2 overflow-x-auto">
      {[['Propel feeds', false], ['For you (Upwork)', true]].map(([label, value]) => (
        <button key={label} type="button" aria-pressed={upwork === value}
          onClick={() => setSelection(value ? scope : null)}
          className={`whitespace-nowrap rounded-md border px-3 py-1.5 text-sm ${upwork === value ? 'border-primary-600 bg-primary-50 text-primary-700' : 'border-gray-300 bg-white text-gray-700'}`}>
          {label}
        </button>
      ))}
    </nav>}
    <div hidden={upwork}>{children}</div>
    {upwork && <UpworkRecommendedFeed key={scope} />}
  </>;
}
